import Tooltip from '@mui/material/Tooltip';
import { withStyles } from '@mui/styles';

var StyleSheet = {
  create: (style) => {
    return style;
  },
};
export var preto = 'black';
export var coricones = preto;
export var color8 = '#F5F5F5'; //cinza ainda maisfraco
export var color4 = '#444444'; //cinza forte
export var color5 = '#2CB200'; //verde
export var color10 = '#3F0000'; //vermelho do login
export var color3 = 'white';
export var color6 = '#FF0000';

export var color1 = 'rgb(140, 0, 0)';

export var color7 = '#EEEEEE'; //cinza fraco
export var color9 = '#FFA400'; //amarelo

export var maxwidth = 900;
export var breakMobile = 880;

export var font = 'Roboto';
export const boxShadow = '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)';
export const orientacaoGrid1 = { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 };
export const orientacaoGrid2 = { xs: 12, sm: 12, md: 12, lg: 12, xl: 12 };

// de m

// xs={12}  sm={12} md={12} lg={12}F xl={12}

export function combineStyles(...styles) {
  return function CombineStyles(theme) {
    const outStyles = styles.map((arg) => {
      // Apply the "theme" object for style functions.
      if (typeof arg === 'function') {
        return arg(theme);
      }
      // Objects need no change.
      return arg;
    });

    return outStyles.reduce((acc, val) => Object.assign(acc, val));
  };
}
export var StyleIconBotao = { style: { color: preto } };
export var StyleIconBotaoDentroBotao = { style: { color: color3 } };
export const gsUI = (theme) => ({
  viewgrafico: {
    borderWidth: 1,
    borderColor: color4,
    borderRadius: 5,
    width: '100%',
    borderStyle: 'solid',
    marginTop: 2.5,
    marginBottom: 2.5,
    // [theme.breakpoints.down(breakMobile)]: {
    //   display: "none"
    // },
  },
});

export const TooltipCustom = withStyles({
  tooltip: {
    fontSize: 14,
    zIndex: '1',
    alignSelf: 'center',
  },
})(Tooltip);
export var styles = StyleSheet.create({
  styleeButtonPure: {
    borderRadius: 20,
    height: 25,
    padding: 2.5,
    paddingLeft: 10,
    borderStyle: 'none',
    fontFamily: font,
    alignSelf: 'center',
  },
  divisor: {
    backgroundColor: color7,
    minWidth: '100%',
    minHeight: 2,
  },
  titulo: {
    fontWeight: 'bold',
    fontSize: 20,
  },
  tituloCenter: {
    fontWeight: 'bold',
    fontSize: 20,
    alignSelf: 'center',
    textAlign: 'center',
    marginTop: 5,
    marginBottom: 5,
  },
  labelimg: {
    marginTop: 15,
    fontWeight: 'bold',
    alignSelf: 'center',
  },
  imageMenu: {
    marginTop: 10,
    width: 450,
    alignSelf: 'center',
    height: 250,
    borderRadius: 5,
  },
  info: { alignSelf: 'center', textAlign: 'center', fontWeight: 'bold', margin: 10 },
  container1: { minWidth: '100%', height: '100%', borderRadius: 5, padding: 20, flex: 1, alignSelf: 'center', justifyContent: 'flex-start' },
});
